import { Component, OnInit, Input } from "@angular/core";
import * as Highcharts from "highcharts";

@Component({
  selector: "bar",
  templateUrl: "./bar.component.html",
  styleUrls: ["./bar.component.scss"],
})
export class BarComponent implements OnInit {
  options: Object;
  toolTipText: string;
  Highcharts = Highcharts;
  @Input()
  chartData;
  @Input()
  categories;
  @Input()
  dataSuffix;
  @Input()
  dataPrefix;
  @Input()
  studentFirstName;

  constructor() {}

  ngOnInit() {
    this.createChart();
  }

  createChart() {
    this.toolTipText =
      (this.studentFirstName !== "" && this.studentFirstName !== "-----"
        ? this.studentFirstName
        : "This student") + " {point.descriptor} in {point.name} {series.name}";
    this.options = {
      chart: {
        type: "column",
      },
      xAxis: {
        categories: this.categories,
        tickWidth: 0,
      },
      yAxis: {
        title: {
          text: null,
        },
        gridLineWidth: 0,
        tickLength: 5,
        tickWidth: 1,
        tickPosition: "outside",
        lineWidth: 1,
      },
      plotOptions: {
        column: {
          stacking: "normal",
        },
        series: {
          dataPrefix: this.dataPrefix || "",
          dataSuffix: this.dataSuffix || "",
        },
      },
      title: { text: null },
      series: [this.chartData],
      credits: false,
      legend: {
        enabled: false,
      },
      tooltip: {
        shared: false,
        useHTML: true,
        borderColor: "#aaa",
        backgroundColor: "rgba(255, 255, 255, 1.0)",
        shadow: false,
        headerFormat: "",
        style: {
          fontFamily: "'Lato', Helvetica, sans-serif",
          backgroundColor: "#FFFFFF",
        },
        pointFormat:
          '<div><span class="metric-tooltip title capitalize tile_body">{point.name} {series.name}</span>' +
          '<span class="metric-tooltip value tooltip_value" style="color: {point.color};">' +
          (this.dataPrefix || "") +
          "{point.y:.,f}" +
          (this.dataSuffix || "") +
          '</span></div><div class="metric-tooltip description body_tooltip_text">' +
          this.toolTipText +
          "</div>",
      },
    };
  }
}
